import React,{Component} from 'react'
import Styles from './style.module.less'
import OrderSearch from './OrderSearch'
import OrderList from './OrderList'
import store from './store'
import {observer} from 'mobx-react'
@observer
export default class extends Component{
    constructor(props) {
        super(props);
        const {location:{query:{tab,status}}}=this.props
        if(tab){store.setTabs(tab)}
        if(status){store.setStatus(status)}

    }

    render(){
        return(
            <div className={Styles.myorder}>
                <div className={Styles.myorderTit}>
                    <h3>我的订单</h3>
                </div>
                <div className={Styles.myorderBox}>
                    <OrderSearch />
                    <OrderList />
                </div>
            </div>
        )
    }
}
